<template>
  <div class="today-alarm">
    <div class="middletitleleft dn-title-bg">
      <div >
        <span>供电偏差</span>
      </div>
      <div class="titleTxtCololr">
        <span>电压偏差:</span>
        <span :class="volatgePass=='合格'?'sc':'ye'" style="margin:0 3px">{{volatgePass}}</span>
        <span style="margin:0 3px">|频率偏差:</span>
        <span :class="frquencyPass=='合格'?'he':'ye'" style="margin:0 3px">{{frquencyPass}}</span>
      </div>

    </div>
    <div class="middlelift dn-content-bg table-warp"
         v-loading="ifLoad">
      <el-table :data="tableData"
                :span-method="objectSpanMethod"
                size="small"
                style="width: 100%;border-radius:4px;"
                height="100%"
                :stripe="true"
                >
                <!-- :cell-style="tableCellStyle"
                :header-cell-style="tableHeaderColor" -->
        <el-table-column align="center"
                         :show-overflow-tooltip="true"
                         prop="voltage"
                         label=""></el-table-column>
        <el-table-column align="center"
                         :show-overflow-tooltip="true"
                         prop="name"
                         label=""></el-table-column>
        <el-table-column align="center"
                         :show-overflow-tooltip="true"
                         prop="realTime"
                         label="实时值">
        </el-table-column>
        <el-table-column align="center"
                         :show-overflow-tooltip="true"
                         label="历史最大值">
          <el-table-column align="center"
                           :show-overflow-tooltip="true"
                           prop="max"
                           label="数值">
          </el-table-column>
          <el-table-column align="center"
                           :show-overflow-tooltip="true"
                           prop="maxTime"
                           label="时间">
          </el-table-column>
        </el-table-column>
        <el-table-column align="center"
                         :show-overflow-tooltip="true"
                         label="历史最小值">
          <el-table-column align="center"
                           :show-overflow-tooltip="true"
                           prop="min"
                           label="数值">
          </el-table-column>
          <el-table-column align="center"
                           :show-overflow-tooltip="true"
                           prop="minTime"
                           label="时间">
          </el-table-column>
        </el-table-column>
        <el-table-column align="center"
                         :show-overflow-tooltip="true"
                         label="偏差"
                         >
          <el-table-column align="center"
                           :show-overflow-tooltip="true"
                           prop="deviation"
                           label="偏差">
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
let vm
import uuidv1 from 'uuid/v1'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    ifLoad: {
      type: Boolean,
      default: false
    },
    volatgePass: {
      type: String,
      default: '标题'
    },
    frquencyPass: {
      type: String,
      default: '标题'
    }
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {
    //改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #F3F3F3;color: #666;'
      }
    },
    //设置单元格样式
    tableCellStyle (row,column, rowIndex, columnIndex) {
        if(row.columnIndex === 7 ){
            return 'color:#47D5A9'
        }
    },
    //合并行行   rowIndex行索引   columnIndex列索引
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if(this.tableData.length>5){
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return {
                        rowspan: 4,
                        colspan: 1
                    }
                } else if (rowIndex === 4) {
                    return {
                        rowspan: 4,
                        colspan: 1
                    }
                } else if (rowIndex === 8) {
                    return {
                        rowspan: 1,
                        colspan: 2
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            } else {
                if (columnIndex === 1 && rowIndex === 8) {
                    return { rowspan: 0, colspan: 0 }
                }
                return {
                    rowspan: 1,
                    colspan: 1
                }
            }
        }else{
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return {
                        rowspan: 4,
                        colspan: 1
                    }
                } else if (rowIndex === 4) {
                    return {
                         rowspan: 1,
                        colspan: 2
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            } else {
                if (columnIndex === 1 && rowIndex === 4) {
                return { rowspan: 0, colspan: 0 }
                }
                return {
                    rowspan: 1,
                    colspan: 1
                }
            }
        }
      
    }
  },
  watch: {}
} 
</script>
<style lang="scss" scoped>
.today-alarm{
    display: flex;
    flex-flow: column;
    height:100%;
    width:100%;
}
.middletitleleft {
//   background: #0197EE;
  color: #fff;
  font-weight: bold;
  display: flex;
  padding: 5px;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  justify-content: space-between;
}
.middlelift {
  height: calc(100% - 33px);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
//   padding: 5px;
}
.realTimeStatuis {
  border-color: red;
  background-color: red;
  color: #fff;
}
.ye {
  color: #F86666;
}

.he{
    color:#1a0fbd
}

</style>